export default "__VITE_ASSET__DwKcRqeU__"